import { useQuery } from '@tanstack/react-query';
import restClient from '../common/api/restClient';

export const useProfileBadges = () => {
  const prefix = process.env.REACT_APP_PROXY_PREFIX || '';
  return useQuery({
    queryKey: ['profileBadges'],
    queryFn: async () => {
      const result = await restClient({ url: `${prefix}/profile-badges` });
      return result;
    },
    staleTime: 0,
    cacheTime: 0,
  });
};
